/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
export const documentationLinks = {
  portal: 'https://phenixrts.com/docs/portal/',
  createChannel: 'https://phenixrts.com/docs/sdk_ref/rest-api/channel/#creating-a-channel',
  deleteChannel: 'https://phenixrts.com/docs/sdk_ref/rest-api/channel/#deleting-a-channel',
  forkChannel: 'https://phenixrts.com/docs/sdk_ref/rest-api/channel/#fork-a-channel',
  killChannel: 'https://phenixrts.com/docs/sdk_ref/rest-api/channel/#kill-a-channel',
  createRoom: 'https://phenixrts.com/docs/sdk_ref/rest-api/room/#creating-a-room',
  deleteRoom: 'https://phenixrts.com/docs/sdk_ref/rest-api/room/#deleting-a-room',
  terminateStream: 'https://phenixrts.com/docs/sdk_ref/rest-api/overview/#terminating-a-stream',
  RTMP: 'https://phenixrts.com/docs/integration-guides/rtmp/',
  FFmpeg: 'https://phenixrts.com/docs/integration-guides/3rd-party-encoders/ffmpeg/',
  WHIP: 'https://phenixrts.com/docs/integration-guides/whip/',
  supportedStreamCapabilities: 'https://phenixrts.com/docs/knowledge-base/reference/capabilities/#supported-stream-capabilities',
  releaseNotes: 'https://phenixrts.com/docs/portal/portal-release-notes/'
};

export const phenixWebSiteLinks = {
  privacyPolicyProduction: 'https://www.phenixrts.com/privacy-policy',
  privacyPolicyStaging: 'https://www-stg.phenixrts.com/privacy-policy',
  termsOfServiceProduction: 'https://www.phenixrts.com/terms-of-service',
  termsOfServiceStaging: 'https://www-stg.phenixrts.com/terms-of-service',
  mainWebSite: 'https://www.statsperform.com'
};